module.exports = __webpack_public_path__ + "img/cover-conway.0e1c0224.png";